<div class="micromate-iframe">
    <iframe (load)="iframeReady()" [src]="mediaLink | safe"
            allowfullscreen
            class="micromate-iframe-media"
            data-dashlane-frameid="4084">
    </iframe>
</div>

